import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container, Label, Value } from './styles';
import { sinceYears, formatPercent } from '../shared-utils';

const Values = styled(Value)`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  & > small {
    margin: 0 2px 0 4px;
    font-weight: ${props => props.theme.fontWeightBold};
    white-space: nowrap;
  }

  & > span {
    font-size: 14px;
    font-weight: ${props => props.theme.fontWeightRegular};
    white-space: nowrap;

    ${props => props.theme.isMobileOrTablet && `
      font-size: 12px;
      line-height: 120%;
      width: 100%;
    `};
  }
`;

export default function GrowthSinceInceptionFact({ date, percent }) {
  return (
    <Container>
      <Label>growth since inception</Label>
      <Values>
        {formatPercent(percent)}
        <small>p.a.</small>
        <span>{sinceYears(date)}</span>
      </Values>
    </Container>
  );
}

GrowthSinceInceptionFact.propTypes = {
  date: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
};
